<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="showMerchantEditProductSideBar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'700px'}">
    <ng-template pTemplate="header">
        <div style="margin: 20px 0px 0px 5px;">
            <div class="cp-header-title">{{product.Name}}</div>
            <!--<div class="cp-header-sub-title">Please enter detailst</div>-->
        </div>
    </ng-template>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div *ngIf="!loading">
        <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 155px)'}"
                       [styleClass]="'app-scrollpanel'">
            <p-tabMenu [model]="menuItems" [activeItem]="menuItems[0]"></p-tabMenu>

            <div *ngIf="activeMenuTab === menuTab.ProductDetails">
                <div class="flex flex-row">
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <div class="merchant-label">Product Image</div>
                            <div class="cp-upload-img-block" (click)="handleImageClick('idImgInput')">
                                <div class="cp-upload-img-block__upload" *ngIf="!product.ImageUrl">
                                    <div>
                                        <img src="/XpressApp/assets/images/upload.svg" />
                                    </div>
                                    <div class="cp-upload-img-block__title">Upload image <br /> Min 100x100px</div>
                                </div>
                                <input id="idImgInput"
                                       type="file"
                                       accept="image/*"
                                       style="display: none"
                                       (change)="handleImageChange($event)" required />
                                <img class="cp-upload-img-block__img" src="{{product.ImageUrl}}" />
                            </div>
                        </div>
                    </div>
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <div class="merchant-label">Product Name *</div>
                            <input type="text" [(ngModel)]="product.Name"
                                   (input)="checkFieldForRequired()"
                                   placeholder="Maximum 100 characters" pInputText />
                        </div>
                        <div class="merchant-form">
                            <div class="merchant-label">Category *</div>
                            <p-dropdown [options]="allCategories"
                                        [(ngModel)]="selectedParentCategory"
                                        [optionLabel]="'Name'"
                                        [filter]="true"
                                        [filterBy]="'Name'"
                                        [style]="{width:'100%'}"
                                        placeholder="Choose category"
                                        (onChange)="handleParentCategoryChange()"
                                        [showClear]="true"
                                        appendTo="body">
                            </p-dropdown>
                        </div>
                        <div class="merchant-form">
                            <div class="merchant-label">Sub Category *</div>
                            <p-dropdown [options]="categories"
                                        [(ngModel)]="product.CategoryId"
                                        [optionLabel]="'Name'"
                                        [optionValue]="'Id'"
                                        [filter]="true"
                                        [filterBy]="'Name'"
                                        [style]="{width:'100%'}"
                                        placeholder="Choose sub category"
                                        [showClear]="true"
                                        (onChange)="checkFieldForRequired()"
                                        [disabled]="!selectedParentCategory"
                                        appendTo="body">
                            </p-dropdown>
                        </div>
                        <div class="merchant-form">
                            <div class="merchant-label">SKU <i class="cp-label-italic">(optional)</i></div>
                            <p-inputNumber inputId="integeronly" [(ngModel)]="product.SKU"> </p-inputNumber>
                        </div>
                    </div>
                </div>

                <div class="merchant-form">
                    <div class="merchant-label">Product Description *</div>
                    <textarea class="textarea-description" rows="7" cols="30" [(ngModel)]="product.Description"
                              (input)="checkFieldForRequired()"
                              pInputTextarea placeholder="Maximum 500 characters"></textarea>
                </div>

                <div class="merchant-form">
                    <div class="merchant-label">Tags</div>
                    <div class="merchant-sub-label">TIP: Use Tags help inform customers about dietary requirements (example Vegan)</div>
                    <div class="flex flex-row">
                        <div class="erchant-column merchant-column-50" *ngIf="tags">
                            <p-dropdown [options]="tags"
                                        [(ngModel)]="selectTag"
                                        [optionLabel]="'Name'"
                                        [filter]="true"
                                        [filterBy]="'Name'"
                                        [style]="{width:'80%'}"
                                        placeholder="Choose tags"
                                        [showClear]="true"
                                        appendTo="body">
                            </p-dropdown>
                            <button class="product-plus-tag-btn" pButton icon="pi pi-plus"
                                    (click)="addTag()"></button>
                        </div>
                    </div>

                    <div style="margin-top: 15px;">
                        <span class="product-tag" *ngFor="let tag of foundTags; let i = index;">
                            {{tag.Name}} <i class="pi pi-times remove-product-tag" (click)="deleteTag(i)"></i>
                        </span>
                    </div>

                </div>
            </div>

            <div *ngIf="activeMenuTab === menuTab.Pricing">
                <div class="flex flex-row">
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <div class="merchant-label">Cost Price</div>
                            <div class="flex flex-row">
                                <div class="cp-price-block">
                                    <span class="cp-p-money">₱</span>
                                </div>
                                <div>
                                    <p-inputNumber inputId="locale-us" mode="decimal" locale="en-US"
                                                   [(ngModel)]="product.Items[0].CostPrice"
                                                   [minFractionDigits]="2"></p-inputNumber>
                                </div>
                            </div>

                        </div>
                        <div class="merchant-form ml-20">
                            <div class="cp-form-title">Optional:</div>
                            <div class="cp-form-subtitle">Enter this value to calculate your profit</div>
                        </div>
                    </div>
                    <div class="merchant-column merchant-column-50">
                    </div>
                </div>
                <div class="flex flex-row">
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <div class="merchant-label">Selling Price*</div>
                            <div class="flex flex-row">
                                <div class="cp-price-block">
                                    <span class="cp-p-money">₱</span>
                                </div>
                                <div>
                                    <p-inputNumber inputId="locale-us" mode="decimal" locale="en-US"
                                                   [(ngModel)]="product.Items[0].SellingPrice"
                                                   (ngModelChange)="checkFieldForRequired()"
                                                   [minFractionDigits]="2"></p-inputNumber>
                                </div>
                            </div>
                        </div>
                        <div class="merchant-form ml-20">
                            <div class="field-checkbox">
                                <p-checkbox name="sp-vat" [(ngModel)]="product.Items[0].UseVat" [binary]="true" inputId="vat"></p-checkbox>
                                <label for="vat">Includes VAT</label>
                            </div>
                        </div>
                    </div>
                    <div class="merchant-column merchant-column-50">
                    </div>
                </div>
                <div class="flex flex-row">
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <div class="merchant-label">VAT Amount  </div>
                            <div class="flex flex-row">
                                <div class="cp-price-block">
                                    <span class="cp-p-money">₱</span>
                                </div>
                                <div>
                                    <p-inputNumber class="cp-input-cost-price" inputId="locale-us" mode="decimal" locale="en-US"
                                                   [(ngModel)]="product.Items[0].Vat"
                                                   [minFractionDigits]="2"></p-inputNumber>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="merchant-column merchant-column-50">
                    </div>
                </div>
                <div class="flex flex-row">
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <div class="merchant-label">Displayed Price</div>
                            <div class="flex flex-row">
                                <div class="cp-price-block">
                                    <span class="cp-p-money">₱</span>
                                </div>
                                <div>
                                    <p-inputNumber inputId="locale-us" mode="decimal" locale="en-US"
                                                   [(ngModel)]="product.Items[0].PublishedPrice"
                                                   [minFractionDigits]="2"></p-inputNumber>
                                </div>
                            </div>
                        </div>
                        <div class="merchant-form ml-20">
                            <div>
                                The price shown to customers in the Xpress app
                            </div>
                        </div>
                    </div>
                    <div class="merchant-column merchant-column-50">
                    </div>
                </div>
            </div>

            <div *ngIf="activeMenuTab === menuTab.UOM">
                <p class="cp-uom-description">
                    The Units of Measure (UOM) describes the weight, volume or quantity of your product.
                    We have two different pricing structures depending on the UOM of the product. Please make sure to use the correct UOM.
                </p>
                <div class="flex flex-row">
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <div class="merchant-label">Select UOM</div>
                            <p-dropdown placeholder="Select" [(ngModel)]="selectedUOMCategory" [options]="uomCategory"
                                        optionLabel="name" optionValue="value" [showClear]="true"></p-dropdown>
                        </div>
                    </div>
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form" *ngIf="selectedUOMCategory !== null && selectedUOMCategory !== undefined">
                            <div class="merchant-label">How will you sell this product</div>
                            <p-dropdown placeholder="Select" [options]="getUOM()" [(ngModel)]="product.Items[0].UnitId"
                                        (onChange)="checkFieldForRequired()"
                                        optionLabel="name" optionValue="value" [showClear]="true"></p-dropdown>
                        </div>
                    </div>
                </div>
                <div class="flex flex-row">
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form" *ngIf="selectedUOMCategory !== null && selectedUOMCategory !== undefined && selectedUOMCategory !== 'Units'">
                            <div class="merchant-label">How many units does it contain</div>
                            <p-inputNumber inputId="locale-us" mode="decimal" locale="en-US"
                                           [(ngModel)]="product.Items[0].Quantity"
                                           [minFractionDigits]="2"></p-inputNumber>
                        </div>
                    </div>
                    <div class="merchant-column merchant-column-50"></div>
                </div>
            </div>

            <div *ngIf="activeMenuTab === menuTab.ProductAvailability">
                <div>
                    By default, once you publish this product, it will be available at all your locations.
                    If you would like to restrict the availability of this product to certain locations or Location groups, you can do so by adding exclusions below.
                </div>
                <div class="merchant-form">
                    <div class="merchant-label">Exclude from</div>
                    <!--<p-multiSelect [options]="stores" [(ngModel)]="product.ExcludePproductFromStores" class="multiselect" defaultLabel="Search store" optionLabel="Name"
            optionValue="Id"
            selectedItemsLabel="{0} items selected"></p-multiSelect>-->
                    <span class="p-fluid">
                        <p-autoComplete field="Name"
                                        [suggestions]="searchStores"
                                        (completeMethod)="searchStoresByMerchant($event)"
                                        placeholder="Search store"
                                        [inputStyle]="{'padding': '10px 15px'}"
                                        (onSelect)="clickStore($event)">
                            <!--<ng-template let-selectedValue pTemplate="selectedItem">
                        <span class="selected-item">{{ selectedValue?.Name }}</span>
                    </ng-template>
                    <ng-template let-option pTemplate="item">
                        {{option.Name}}
                    </ng-template>-->
                        </p-autoComplete>
                    </span>
                </div>

                <div class="merchant-form" *ngIf="product.ExcludePproductFromStores !== null">
                    <div class="merchant-label">Excluded: ({{product.ExcludePproductFromStores.length}} stores)</div>
                    <div class="merchant-select-stores-block">
                        <p-scrollPanel [style]="{width:'100%', height: '465px'}"
                                       [styleClass]="'app-scrollpanel'">
                            <div class="flex flex-row merchant-select-stor" *ngFor="let store of product.ExcludePproductFromStores; let i = index;">
                                <div class="merchant-select-stores-img">
                                    <img src="{{store.ImageUrl}}" />
                                </div>
                                <div class="merchant-select-stores-name">
                                    {{store.Name}}
                                </div>
                                <div class="merchant-select-stores-delete">
                                    <i class="pi pi-times remove-product-tag" (click)="deleteStore(i)"></i>
                                </div>
                            </div>
                        </p-scrollPanel>
                    </div>
                </div>
            </div>

            <div *ngIf="activeMenuTab === menuTab.Inventory">
                <div class="cp-inventory-description">
                    Daily inventory levels are the quantity available for sale each day.
                    This value resets at midnight daily. If you have multiple locations, this will be the default inventory for each location.
                    You can adjust this on the Location level if each location has different inventory levels.
                </div>
                <div class="cp-daily-inventory-level-block">
                    <div class="cp-inventory-title">Daily Inventory Level</div>
                    <!--<div class="cp-inventory-text">
                Each product requires its own inventory level so it can be displayed in your store.
                This quantity is used to adjust what products your store has available everyday.
                This quantity resets daily at midnight.
                <p>For example, if you set the product inventory to ’10’ this means 10 items can be sold daily.</p>
            </div>-->
                </div>
                <div class="merchant-column merchant-column-50">
                    <div class="merchant-form">
                        <div class="merchant-label">Daily Inventory <span (click)="openDialogInfo(infoForFields.DailyInventory)"><img src="/XpressApp/assets/images/info.svg" /></span></div>
                        <p-inputNumber inputId="integeronly" [(ngModel)]="product.Items[0].DefaultAmount"></p-inputNumber>
                    </div>
                </div>

                <div class="merchant-label">Send low inventory email <span (click)="openDialogInfo(infoForFields.SendLowInventoryEmail)"><img src="/XpressApp/assets/images/info.svg" /></span></div>
                <!--<div class="merchant-sublabel">We can send a reminder email when you get below a certain qty</div>-->
                <div class="flex flex-row">
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <p-inputNumber inputId="integeronly" placeholder="Enter qty" [(ngModel)]="product.Items[0].LowInventoryQuantity"></p-inputNumber>
                        </div>
                    </div>
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <input type="text" placeholder="Enter email" pInputText [(ngModel)]="product.Items[0].LowInventoryEmail" />
                        </div>
                    </div>
                </div>
                <hr />
                <div class="cp-daily-inventory-level-block">
                    <div class="cp-inventory-title">Supplier <span (click)="openDialogInfo(infoForFields.Supplier)"><img src="/XpressApp/assets/images/info.svg" /></span></div>
                    <!--<div class="cp-inventory-text">
                By adding your supplier, we can send alerts when products reach a low threshold level, reminding you too reorder.
            </div>-->
                </div>
                <div class="merchant-column merchant-column-50">
                    <div class="merchant-form">
                        <div class="merchant-label">Supplier name</div>
                        <!--<div class="merchant-sublabel">The name of the supplier your purchase from.</div>-->
                        <input type="text" placeholder="Enter supplier name" pInputText [(ngModel)]="product.Items[0].SupplierName" />
                    </div>
                </div>

                <!--<div class="cp-daily-stock-level-block">
            <div class="field-checkbox">
                <p-checkbox name="sp-vat" [(ngModel)]="product.Items[0].ReduceQuantityDailyStockLevel" [binary]="true" inputId="rqdsl"></p-checkbox>
                <label for="rqdsl">Reduce quantity from Daily Stock Level</label>
            </div>
            <div class="field-checkbox">
                <p-checkbox name="sp-vat" value="Add a separate stock level Value" [binary]="true" inputId="asslv"></p-checkbox>
                <label for="asslv">Add a separate stock level Value</label>
            </div>
            <div class="merchant-form">
                <span class="cp-p-money">₱</span><p-inputNumber class="cp-input-cost-price" inputId="locale-us" mode="decimal" locale="en-US"
                                                                [(ngModel)]="product.Items[0].StockLevelValue"
                                                                [minFractionDigits]="2"></p-inputNumber>
            </div>
        </div>-->
            </div>

            <p-dialog header="{{dialogInfoObj.Header}}" [(visible)]="showDialogInfo" [modal]="true" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
                <p class="m-0">
                    {{dialogInfoObj.Description}}
                </p>
            </p-dialog>

        </p-scrollPanel>
        <div class="flex flex-row">
            <div class="merchant-footer-right-block">
                <button class="outlined-red-btn" pButton label="Cancel" (click)="cancel()"></button>
                <button class="bluedark-btn" pButton label="Save Changes" (click)="updateProduct()" [disabled]="isBtnSaveDisabled"></button>
            </div>            
        </div>
    </div>

</p-sidebar>